
define('template!sdsServiceListMenu',['directive!sdcTransclude'],function(template){return '<div>\r\n\t<div ng-if="vm.selected">\r\n\t\t<sdc-transclude init="vm.transcludeSelected($scope, $elements)"></sdc-transclude>\r\n\t</div>\r\n\t<div>\r\n\t\t<sdc-transclude init="vm.transcludeItemArea($scope, $elements)">\r\n\t</div>\r\n</div>';});

